<svg width="61" height="17" viewBox="0 0 61 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="arrow-green">
        <path id="Path 8" d="M1.5 15C1.5 15 15.8425 1.91872 30 1.85663C44.1575 1.79454 58.5 14.75 58.5 14.75"
              stroke="#77E0C8" strokeWidth="2" stroke-linecap="round" stroke-dasharray="2 4"/>
        <path id="Path 3" d="M54.5 15.75H59.5V10.75" stroke="#77E0C8" strokeWidth="1.5"/>
    </g>
</svg>
